import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Public careers API — no auth required. Uses its own axios instance so it
// never inherits interceptors from portal/admin instances.
const careersHttp = axios.create({ baseURL: API });

export const careersApi = {
    listJobs: () => careersHttp.get("/jobs").then((r) => r.data),
    getJob: (slug) => careersHttp.get(`/jobs/${slug}`).then((r) => r.data),
    /** Submit a multipart application. `formData` must be a FormData instance. */
    submitApplication: (formData) =>
        careersHttp
            .post("/applications", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((r) => r.data),
};
